<script>
  export default {
    name: 'dashboard-featured',

    props: {
      backgroundImg: String,
      appName: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        styleBackground: {
          backgroundImage: `url('${this.backgroundImg}')`
        }
      }
    }
  }
</script>

<template>
  <section>
    <h5>Featured for you</h5>

    <div class="featured card">
      <div class="bg" v-bind:style="styleBackground" v-if="backgroundImg"></div>
      <div class="content">
        <h5>Featured</h5>
        <h2>{{ appName }}</h2>
        <p>{{ description }}</p>

        <b-button variant="primary">Add App</b-button>
      </div>
    </div>
  </section>
</template>

<style src="./DashboardFeatured.scss" lang="scss" scoped></style>
